<mat-card appearance="outlined" id="login-onboard-district-card">
  <mat-card-content>
    @if ((bannerStatus$ | async)) {
      <mat-toolbar
        id="login-banner"
        color="{{ bannerColor$ | async }}"
        fxFlexFill
        >
        <span id="login-banner-message">
          {{ bannerMessage$ | async }}
        </span>
      </mat-toolbar>
    }

    @if ((showProgressBar$ | async)) {
      <mat-progress-spinner
        mode="indeterminate"
        color="primary"
        fxLayoutAlign="center"
        >
      </mat-progress-spinner>
    }

    <div id="registration-form-container">
      @if (authorized) {
        <form
          novalidate
          id="registration-form"
          [formGroup]="registrationForm"
          (ngSubmit)="submit()"
          >
          <div id="district-name-banner">
            Teacher Sign Up for {{ tokenPayload?.districtName }}
          </div>
          <mat-form-field>
            <mat-select
              placeholder="Select School"
              formControlName="school"
              required
              >
              @for (
                school of tokenPayload?.schools; track trackBySchool($index,
                school)) {
                <mat-option
                  [value]="school.schoolid"
                  >
                  {{ school.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <input
              id="login-registration-email"
              matInput
              placeholder="Email"
              formControlName="email"
              required
              />
            @if (validate('email', 'required')) {
              <mat-error>
                Email is required
              </mat-error>
            }
            @if (
              validate('email', 'email') &&
              !validate('email', 'required')
              ) {
              <mat-error
                >
                Value must be a valid email
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input
              id="invite-hash"
              matInput
              placeholder="Invite Code"
              formControlName="inviteHash"
              required
              />
            @if (validate('inviteHash', 'required')) {
              <mat-error>
                Invite code is required
              </mat-error>
            }
          </mat-form-field>
          <div fxLayout="row row" fxLayoutAlign="center center">
            <button
              fxFlex="48"
              id="cancel-button"
              mat-raised-button
              color="default"
              type="button"
              (click)="goToLoginForm()"
              >
              Cancel
            </button>
            <div fxFlex="4"></div>
            <button
              fxFlex="48"
              id="registration-button"
              mat-raised-button
              color="primary"
              type="submit"
                        [disabled]="
                            registrationForm.untouched ||
                            !registrationForm.valid ||
                            !authorized
                        "
              >
              Continue
            </button>
          </div>
          @if ((showProgressBar$ | async)) {
            <mat-progress-bar
              mode="indeterminate"
            ></mat-progress-bar>
          }
        </form>
      }
    </div>
    @if (!authorized && !(showProgressBar$ | async)) {
      <mat-card-actions
        id="card"
        >
        <button
          id="cancel-link"
          mat-raised-button
          fxFlexFill
          color="primary"
          (click)="goToLoginForm()"
          >
          Back to Login
        </button>
      </mat-card-actions>
    }
  </mat-card-content>
</mat-card>
